export const getApplicationLibraryClassUsageCount = ({
  applicationID,
  library: { libraryClassUsageCounts }
}) => {
  const usage =
    Array.isArray(libraryClassUsageCounts) &&
    libraryClassUsageCounts.find(
      (usageCount) => usageCount.appId === applicationID
    )
  return usage ? usage.usageCount : undefined
}
